module.exports = __webpack_public_path__ + "img/note.cf5dc826.png";